import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import AddEmployeeTypeForm from "./AddEmployeeTypeForm";
import AddEmployeeCategoryForm from "./AddEmployeeCategoryForm";
import { addData, clearQueryResult, queryEmployeeType, queryEmployeeCategory } from "../../actions/valueActions";

const AddEmployeeData = ({ id, industry, type, cost_category, employeeCategories, handleClose }) => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();

    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);

    const queryResult = useSelector(state => state.value.queryResult)

    const handleTabChange = (event, newValue) => {
        dispatch(clearQueryResult())
        setTab(newValue);
    };

    const addCostFormAction = () => {
        return (
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    type="submit"
                    disabled={loading}
                    sx={{ textTransform: 'none' }}
                >
                    Request
                </Button>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',  // half of 24
                            marginLeft: '-12px', // half of 24
                            zIndex: 1,
                        }}
                    />
                )}
            </Box>
        )
    }

    const saveCostFormAction = () => {
        return (
            <React.Fragment>
                <Button
                    startIcon={<SaveIcon />}
                    type="submit"
                    sx={{ textTransform: 'none' }}
                >
                    Save
                </Button>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    onClick={() => dispatch(clearQueryResult())}
                    sx={{ textTransform: 'none' }}
                >
                    Rerun Request
                </Button>
            </React.Fragment>
        )
    }

    const onSubmitEmployeeType = async (values, { setSubmitting }) => {
        values.industry = industry
        values.cost_category = cost_category
        
        setLoading(true)
        let success = false

        const result = await dispatch(queryEmployeeType(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitEmployeeCategory = async (values, { setSubmitting }) => {
        values.industry = industry
        values.cost_category = cost_category
        values.cost_type = values.employee_category
        values.cost_sub_type = values.employee_type

        setLoading(true)
        let success = false

        const result = await dispatch(queryEmployeeCategory(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitSaveEmployeeType = (values) => {
        values.lower = values.lower.toString().replace(/,/g, "");
        values.higher = values.higher.toString().replace(/,/g, "");
        values.cost_type = values.employee_category
        values.cost_sub_type = values.employee_type

        dispatch(addData(id, type, 'cost_sub_type', values))

        handleClose()
    }

    const onSubmitSaveEmployeeCategory = (values) => {
        values.cost_type = values.employee_category

        let costPerMultiple = values.cost_per_multiple

        Object.keys(costPerMultiple).forEach(subType => {
            costPerMultiple[subType].lower = costPerMultiple[subType].lower.toString().replace(/,/g, '');
            costPerMultiple[subType].higher = costPerMultiple[subType].higher.toString().replace(/,/g, '');
        });

        values.cost_per_multiple = costPerMultiple

        dispatch(addData(id, type, 'cost_type', values))

        handleClose()
    }

    function renderAddEmployeeType() {
        // dispatch(clearQueryResult())

        return (
            <AddEmployeeTypeForm
                employeeCategories={employeeCategories}
                queryResult={queryResult}
                formActions={addCostFormAction}
                formResultActions={saveCostFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitEmployeeType(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveEmployeeType}
                ref={formikRef}
            />
        )
    }

    function renderAddEmployeeCategory() {
        // dispatch(clearQueryResult())

        return (
            <AddEmployeeCategoryForm
                employeeCategories={employeeCategories}
                queryResult={queryResult}
                formActions={addCostFormAction}
                formResultActions={saveCostFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitEmployeeCategory(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveEmployeeCategory}
                ref={formikRef}
            />
        )
    }

    return (
        <Box>
            <Tabs
                value={tab}
                onChange={handleTabChange}
                sx={{ mb: 2, textTransform: 'none' }}
            >
                <Tab label="Add Employee Type" />
                <Tab label="Add Employee Category" />
            </Tabs>
            {tab === 0 &&
                renderAddEmployeeType()
            }
            {tab === 1 &&
                renderAddEmployeeCategory()
            }
        </Box>
    )
}

export default AddEmployeeData 